import React from "react";
import {useFormContext} from "react-hook-form";

import { Transfer } from 'antd';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/ro';

import * as DateHelper from '../util/DateHelper';
import * as Consts from '../constants/Consts';
import * as CustomStyles from '../styles/CustomStyles';
import * as ValidationMessages from '../constants/ValidationMessages';
import * as DataPattern from '../constants/DataPattern';
import * as SelectData from '../constants/CustomSelectData';
import { RoleClient, ClientType } from "../constants/Consts";
import * as Const from '../constants/SystemConstants';
import CustomSelect from '../custom/CustomSelectComponent'
import * as SelectTypes from '../constants/CustomSelectTypes'
import * as AFUtility from '../util/AFUtility';

//
// It is expected that <FormProvider> provides all the hook methods in the parent before calling the below components
// The components access the methods (register, formState, errors, etc...) by using useFormContext()
// lUser is expected to be in the local form state
//

export function RenderGeneralSection(props) {
    console.log('Sectiune Generala...');
    const { register, setValue, trigger, watch, formState: { errors, defaultValues } } = useFormContext();

    const [checkedActive, setCheckedActive] = React.useState(!!defaultValues.lUser.generalSection.active ? defaultValues.lUser.generalSection.active : false);
    const [selectedRoleId, setSelectedRoleId] = React.useState( !!defaultValues.lUser.generalSection.role ? defaultValues.lUser.generalSection.role : '');

    const [roleSelectData, setRoleSelectData] = React.useState( defaultValues.lUser.generalSection.clientId === Consts.COREVO_CLIENT_ID ? SelectData.roleSystem : SelectData.roleClient);

    const [showSelector, setShowSelector] = React.useState( defaultValues.lUser.generalSection.role === RoleClient.UserSpecificEmployer ? true : false);

    const [xferSourceData, setXferSourceData] = React.useState([]);
    const [xferTargetKeys, setXferTargetKeys] = React.useState([]);    


    const setWorksiteTransferData = () => {
        var tempTargetKeys = [];
        const tempSourceData = [];

        props.worksites.forEach(worksite => {
            const employer = props.employers.find(employer => employer.id === worksite.generalSection.employerId)
            const erName = employer ? employer.generalSection.employerName : 'NA';
            const wsDec = erName + ' - '
                + worksite.generalSection.name + ', '
                + worksite.generalSection.judet + ', '
                + worksite.generalSection.localitate;
            const data = {
                // key: worksite.id.toString(),
                key: worksite.generalSection.employerId + '#' + worksite.id,
                title: wsDec,
                description: wsDec,
                chosen: false,
            };
            tempSourceData.push(data);
        })

        if (!!defaultValues.lUser.generalSection.permissionedWS) {
            tempTargetKeys = defaultValues.lUser.generalSection.permissionedWS;
        }

        setXferSourceData(tempSourceData);
        setXferTargetKeys(tempTargetKeys);
    };

    const handleTransferChange = (newTargetKeys) => {
        setXferTargetKeys(newTargetKeys);
        setValue("lUser.generalSection.permissionedWS", newTargetKeys);

        // for convenience, store the Employer Ids
        var mySet = new Set(); 
        newTargetKeys.forEach((wsKeyId) => {
            if(!AFUtility.isString(wsKeyId) || !wsKeyId.includes('#')) 
                return;
            const wsId = parseInt(wsKeyId.split('#')[1]);
            props.worksites
                .filter(worksite => worksite.id === wsId )
                .forEach(worksite => mySet.add(worksite.generalSection.employerId));

        })
        setValue("lUser.generalSection.permissionedER", Array.from(mySet));
    };

    React.useEffect(() => {
        setWorksiteTransferData();
    }, []);      

    const handleRoleChange = (roleId) => {
        setSelectedRoleId(roleId);
        roleId === RoleClient.UserSpecificEmployer ? setShowSelector(true) : setShowSelector(false);
    }


    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nume Utilizator (Email)" fullWidth margin="dense" disabled={!!defaultValues.lUser.id}
                        {...register("lUser.generalSection.username", 
                        {required: ValidationMessages.REQUITED_MESSAGE,               
                            pattern: {
                                value: DataPattern.PATTERN_EMAIL_ADDRESS,
                                message: ValidationMessages.INVALID_EMAIL_ADDRESS,
                            }  
                            }
                        )} 
                        error={!!errors?.lUser?.generalSection?.username}
                        helperText={errors?.lUser?.generalSection?.username ? errors.lUser.generalSection.username.message : null}
                        onChange={(event) => { 
                                setValue('lUser.generalSection.email', event.target.value); 
                                trigger('lUser.generalSection.email'); 
                            }
                        }
                    />
                </Grid>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={5}>
                    <FormControlLabel 
                        control={ 
                            <Checkbox
                                {...register('lUser.generalSection.active')}                         
                                checked={checkedActive} 
                                onChange={(event) => setCheckedActive(event.target.checked)}
                            /> 
                        } 
                        label="Activ" 
                    />
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nume" fullWidth margin="dense" 
                        {...register("lUser.generalSection.lastName", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lUser?.generalSection?.lastName}
                        helperText={errors?.lUser?.generalSection.lastName ? errors.lUser.generalSection.lastName.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Prenume" fullWidth margin="dense" 
                        {...register("lUser.generalSection.firstName", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lUser?.generalSection?.firstName}
                        helperText={errors?.lUser?.generalSection?.firstName ? errors.lUser.generalSection.firstName.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Email" fullWidth margin="dense" disabled
                        {...register("lUser.generalSection.email", 
                            {required: ValidationMessages.REQUITED_MESSAGE,               
                            pattern: {
                                value: DataPattern.PATTERN_EMAIL_ADDRESS,
                                message: ValidationMessages.INVALID_EMAIL_ADDRESS,
                            }  
                            }
                        )} 
                        error={!!errors?.lUser?.generalSection?.email}
                        helperText={errors?.lUser?.generalSection?.email ? errors.lUser.generalSection.email.message : null}
                        inputRef={register()}
                        InputLabelProps={{ shrink: !!watch('lUser.generalSection.email') }}
                        />
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <FormControl fullWidth size="small" margin="dense" variant="standard">
                        <InputLabel id={'daRole-inputLabelId'} error={!!errors?.lUser?.generalSection?.role}>Rol Utilizator</InputLabel>
                        <Select
                            {...register('lUser.generalSection.role', {required: ValidationMessages.REQUITED_MESSAGE})}
                            labelId={'daRole-selectLabelId'}
                            id={'daRole'}
                            value={selectedRoleId}
                            onChange={(event) => handleRoleChange(event.target.value)}
                            label={'daRole-label'}
                            error={!!errors?.lUser?.generalSection?.role}
                            >
                            {
                                roleSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                            }
                        </Select>
                        <Typography sx={{ color: 'error.main', fontSize: 12 }}>{errors?.lUser?.generalSection?.role ? errors.lUser.generalSection.role.message : null}</Typography>
                    </FormControl>
                </Grid>
                <Grid item xs={4}>
                </Grid>
                <Grid item xs={4}>
                </Grid>

                {/*row*/}
                <Grid item xs={12}>
                    {showSelector &&
                        <Transfer
                            dataSource={xferSourceData}
                            showSearch
                            listStyle={{
                                width: '100%',
                                height: 300,
                            }}
                            targetKeys={xferTargetKeys}
                            onChange={handleTransferChange}
                            render={(item) => item.title}
                        />
                    }
                </Grid>

            </Grid>
        </Box>
    );
}


export function RenderAuthorizationsSection(props) {
    console.log('Sectiune Autorizatii...');

    const { register, setValue, formState: { errors, defaultValues } } = useFormContext();

    const [dateAuthorization, setDateAuthorization] = React.useState(dayjs(`${defaultValues.lUser.autorizatie?.dataAutorizatie}`));
    const [dateIssue, setDateIssue] = React.useState(dayjs(`${defaultValues.lUser.autorizatie?.dataEliberare}`));
    const [validUntil, setValidUntil] = React.useState(dayjs(`${defaultValues.lUser.autorizatie?.dataExpirare}`));

    const validateAuthorizationDate = (dataAuthorizationStr) => {
        if( DateHelper.isValidStringDateFmt(dataAuthorizationStr) ) {
            return true;
        }
        else {
            return 'Format data este invalid';
        }
    }

    const validateDataEliberareAutorizatie = (dataEliberareStr) => {
        if(dataEliberareStr){
            if( DateHelper.isValidStringDateFmt(dataEliberareStr) ) {
                const dataEliberare = DateHelper.getDateFromString(dataEliberareStr);
                if(dataEliberare < dateAuthorization) {
                    return 'Data Eliberare este inainte de Data Autorizatie';
                }
                else{
                    return true;
                }
            }
            else {
                return 'Format data este invalid';
            }    
        }
        else {
            return true;
        }
    }

    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Typography color="text.primary" paddingTop={1} paddingLeft={1}>Operator RSVTI</Typography>

            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nr. Autorizatie" fullWidth margin="dense" 
                        {...register("lUser.autorizatie.authNo", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lUser?.autorizatie?.authNo}
                        helperText={errors?.lUser?.autorizatie?.authNo ? errors.lUser.autorizatie.authNo.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            disabled={!!props.disabled ? props.disabled : false}
                            label="Data Autorizatie"
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={dateAuthorization}
                            onChange={(newValue) => {
                                setDateAuthorization(newValue);
                                if(newValue && newValue.isValid()) {
                                    setValue('lUser.autorizatie.dataAutorizatie', newValue.toISOString());

                                    const expiryDate = newValue.add(Const.AUTHORIZATION_EXPIRATION_YEARS, 'year');
                                    setValidUntil(expiryDate);
                                    setValue('lUser.autorizatie.dataExpirare', expiryDate.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                    {...register('lUser.autorizatie.dataAutorizatie', 
                                        {required: ValidationMessages.REQUITED_MESSAGE, 
                                        validate: vd => validateAuthorizationDate(vd) }
                                    )}
                                    error={!!errors?.lUser?.autorizatie?.dataAutorizatie}
                                    helperText={errors?.lUser?.autorizatie?.dataAutorizatie ? errors.lUser.autorizatie.dataAutorizatie.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker disabled={false}
                            label="Valabila Pana La"
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={validUntil}
                            onChange={(newValue) => {
                                setValidUntil(newValue);
                                if(newValue && newValue.isValid()) {
                                    setValue('lUser.autorizatie.dataExpirare', newValue.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                    {...register('lUser.autorizatie.dataExpirare', {required: ValidationMessages.REQUITED_MESSAGE})}
                                    error={!!errors?.lUser?.autorizatie?.dataExpirare}
                                    helperText={errors?.lUser?.autorizatie?.dataExpirare ? errors.lUser.autorizatie.dataExpirare.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            /*disabled={!!props.disabled ? props.disabled : false}*/
                            label="Data Eliberare Autorizatie"
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={dateIssue}
                            onChange={(newValue) => {
                                setDateIssue(newValue);
                                if(newValue && newValue.isValid()) {
                                    setValue('lUser.autorizatie.dataEliberare', newValue.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                    {...register('lUser.autorizatie.dataEliberare', 
                                            {/*required: ValidationMessages.REQUITED_MESSAGE,*/ 
                                            validate: vd => validateDataEliberareAutorizatie(vd) }
                                    )}
                                    error={!!errors?.lUser?.autorizatie?.dataEliberare}
                                    helperText={errors?.lUser?.autorizatie?.dataEliberare ? errors.lUser.autorizatie.dataEliberare.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={8}>
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <CustomSelect 
                        selectId={'authzsStatus'} 
                        selectType={SelectTypes.AUTHORIZATION_STATUS} 
                        value={defaultValues.lUser.autorizatie?.status} 
                        register={{...register('lUser.autorizatie.status', {required: ValidationMessages.REQUITED_MESSAGE})}}
                        error={!!errors?.lUser?.autorizatie?.status}
                        helperText={errors?.lUser?.autorizatie?.status ? errors.lUser.autorizatie?.status.message : null}
                    />   
                </Grid>
                <Grid item xs={8}>
                </Grid>

            </Grid>
        </Box>
    );
}

